"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _cookieUtils = _interopRequireDefault(require("./cookieUtils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Method = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE'
};
class ErrorWithResponse extends Error {}
function filterUndefinedHeaders(headers) {
  const finalHeaders = {
    'Content-Type': 'application/json'
  };
  Object.keys(headers).forEach(key => {
    if (headers[key] !== undefined) {
      finalHeaders[key] = headers[key];
    }
  });
  return finalHeaders;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleErrors = ([ok, response]) => {
  if (!ok) {
    const errorMessage = response.error && response.error.message || 'An error has occurred';
    const error = new ErrorWithResponse(errorMessage);
    error.response = response;
    throw error;
  }
  return response;
};
const handlePromise = response => {
  const contentType = response.headers && response.headers.get('Content-Type');
  if (contentType && contentType.indexOf('application/json') > -1) {
    return Promise.all([response.ok, response.json()]);
  }
  return Promise.all([response.ok, response.text()]);
};
const request = (url, options) => (0, _isomorphicFetch.default)(url, options).then(handlePromise).then(handleErrors);
const get = (url, options = {}, headers = {}) => {
  const finalHeaders = _objectSpread({
    'Content-Type': 'application/json'
  }, headers);
  const finalOptions = _objectSpread({
    method: Method.get,
    credentials: 'same-origin',
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
const post = (url, body = {}, options = {}, headers = {}) => {
  const finalHeaders = filterUndefinedHeaders(headers); // filter all headers with value of undefined
  const finalBody = finalHeaders['Content-Type'] === 'application/json' ? JSON.stringify(body) : body;
  const finalOptions = _objectSpread({
    method: Method.post,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
const deleteMethod = (url, options = {}, headers = {}) => {
  const finalHeaders = _objectSpread({
    'Content-Type': 'application/json'
  }, headers);
  const finalOptions = _objectSpread({
    method: Method.delete,
    credentials: 'same-origin',
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
const put = (url, body = {}, options = {}, headers = {}) => {
  const finalHeaders = filterUndefinedHeaders(headers); // filter all headers with value of undefined
  const finalBody = finalHeaders['Content-Type'] === 'application/json' ? JSON.stringify(body) : body;
  const finalOptions = _objectSpread({
    method: Method.put,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};

// JASON TODO: Move cookie functions and this entire file to zola-helpers
const getCookie = (cookieName, req) => {
  if (!req.cookies) return undefined;
  return req.cookies[cookieName];
};
const getCookieHeader = req => {
  const authCookieNames = [_cookieUtils.default.getLoginCookieName(), _cookieUtils.default.getUserSessionCookieName(), _cookieUtils.default.getUserSessionRefreshCookieName()];
  const finalString = authCookieNames.reduce((acc, cookieName) => {
    const cookieValue = getCookie(cookieName, req);
    if (cookieValue) {
      return `${acc}${cookieName}=${cookieValue}; `;
    }
    return acc;
  }, '');
  return {
    Cookie: finalString
  };
};
const ApiService = {
  request,
  get,
  put,
  post,
  delete: deleteMethod,
  getCookieHeader
};
var _default = exports.default = ApiService;